<template>
    <div class="wrap">
        <listHeader
            :title="title"
            :scenario="scenario"
            :operate="showOperate"
            @optionFun="headerOptionFun"
        >
        </listHeader>

        <div class="wrap-list-content">

            <search-screen
                :checkData="postData"
                :set-condition="{
                    pagesize: setCondition.pagesizes,
                    field: setCondition.fields,
                }"
                :config="config"
                :scenario="scenario"
                @exportRes="exportRes(0)"
                @setOption="setOption"
                @clear="clear"
                @search="search"
            >
            </search-screen>

            <div class="hro-table hro-table-only">
                <hro-table
                    :columns="columns"
                    :dataSource="data"
                    :loading="loading"
                    :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
                    :scroll="scroll"
                    :rowKey="selectedKey"
                    :operate="showOperate"
                    @actionFun="actionFun"
                >

                </hro-table>
            </div>
        </div>

        <list-bottom
            :page="postData.page"
            :pagesize="postData.pagesize"
            :total="total"
            :data="data"
            :selectedRowKeys="selectedRowKeys"
            :condition="{
                  checkall: true,
              }"
            :scenario="scenario"
            :operate="showOperate"
            @checked="onCheckAllChange"
            @page="pageTo"
            @optionFun="bottomOptionFun"
        >
        </list-bottom>

        <!--拜访-->
        <resume-visit
            v-model="showModal"
            :rid="rid"
            @confirm="getData">
        </resume-visit>

        <!--分配-->
        <resume-assign
            v-model="showModalAssign"
            :rid="rid"
            @confirm="getData">
        </resume-assign>

        <!--安排-->
        <class-student
            v-model="showModalClass"
            :rid="rid"
            @confirm="getData">
        </class-student>

    </div>
</template>

<script>
import $ from 'jquery';
import searchScreen from '@/components/list/searchScreen';
import listBottom from '@/components/list/listBottom';
import hroTable from '@/components/list/table';
import listHeader from '@/components/list/listHeader';
import resumeVisit from '@/components/modal/resumeVisit';
import resumeAssign from '@/components/modal/resumeAssign';
import classStudent from '@/components/modal/classStudent';

export default {
    components: {
        listBottom,
        hroTable,
        searchScreen,
        listHeader,
        resumeVisit,
        resumeAssign,
        classStudent
    },
    data() {
        return {
            title: '简历列表',
            scenario: 'resumeList', // 页面标识
            selectedRowKeys: [], // 选中行的key
            selectedRowKeysItem: [], // 选中行的item
            selectedKey: 'rid', // 数据主键字段（唯一）
            loading: false,// 请求
            scroll: null, //滚动
            data: [],
            setCondition: {
                fields: [],// 显示字段
                pagesizes: {},// 每页显示数筛选条件
            },
            postData: {
                source: 'my',
                from: '',
                keyword: '',
                mid: '',
                vistatus: '',
                status: '',
                fid: '',
                page: 1,
                pagesize: 10,
                showfield: [], // 显示字段
            },
            total: 0,
            config: {},
            showModal: false, // 弹框
            showOperate: '', // 显示操作按钮
            showModalAssign: false,
            showModalClass: false,
            rid: '',
        }
    },
    computed: {
        columns() {
            // 处理显示字段
            let columns = [];
            for (let i in this.setCondition.fields) {
                let index = this.inArray(this.setCondition.fields[i].key, this.postData.showfield);
                if (index > -1) {
                    let item = {
                        title: this.setCondition.fields[i].text,
                        dataIndex: this.setCondition.fields[i].key,
                    };

                    if (i == 0 && this.setCondition.fields[i].default == 1) {
                        item.fixed = 'left';
                        item.width = 100;
                    }

                    if (this.setCondition.fields[i].key == 'mobile') {
                        item.width = 140;
                    }

                    if (this.setCondition.fields[i].key == 'name') {
                        item.scopedSlots = {customRender: 'resume_name'};
                    }

                    if (this.setCondition.fields[i].key == 'remark') {
                        item.scopedSlots = {customRender: 'resume_remark'};
                        item.width = 300;
                    }

                    columns.push(item);
                }
            }

            let item = {
                title: '操作',
                dataIndex: 'resume_action',
                scopedSlots: {customRender: 'resume_action'},
            };

            let len = columns.length;
            if (len >= 7) {
                item.fixed = 'right';
                item.width = 100;
            } else if (len > 0 && len < 7) {
                columns[0].fixed = '';
            }
            columns.push(item);

            let x = 300 + (len - 2) * 150;
            let table_width = $('.hro-table').width();
            this.scroll = x > table_width ? {x: x} : null;

            return columns;
        }
    },
    watch: {
        '$store.state.showLayoutMenu'(val) {
            $('.list-bottom').width($('.wrap-list-content').width());
        },
    },
    created() {
        // 当浏览器大小变化时
        this.listenListWindow();

        // 初始化postData
        this.setData();

        // 请求数据
        this.getData();
    },
    methods: {
        getData() {
            // init
            this.selectedRowKeys = [];

            // 加载等待
            this.loading = true;
            this.http('/manage/resume/list', this.postData, (res) => {
                this.loading = false;

                // 数据渲染
                this.setCondition.fields = res['_fields'];
                this.setCondition.pagesizes = res['_pagesizes'];
                this.data = res.list.data;
                this.total = parseInt(res.list.count);
                this.postData.pagesize = parseInt(res.list.pagesize);
                this.config = res.config;

                // 初始化底部宽度
                this.$nextTick(() => {
                    $('.list-bottom').width($('.wrap-list-content').width());
                });
            }, null, 2);
        },
        // 设置参数
        setData() {
            for (let i in this.postData) {
                if (this.$route.query[i] === undefined) continue;

                if (i === 'showfield') {
                    this.postData[i] = typeof this.$route.query[i] === 'string' ? [this.$route.query[i]] : this.$route.query[i];
                } else {
                    this.postData[i] = this.$route.query[i];
                }
            }

            // 初始化显示字段
            if (this.$route.query['showfield'] === undefined) {
                this.postData['showfield'] = ['name', 'mobile', 'sex_str', 'birth_str', 'vistatus_str', 'remark', 'dateline_str', 'muname', 'from_str', 'updatetime_str'];
            }
        },
        // 头部操作
        headerOptionFun(e) {
            switch (e.op) {
                case 'create':
                    this.$router.push('/resume/create');
                    break;
                default:
                    break;
            }
        },
        // 列表操作
        actionFun(e) {
            switch (e.op) {
                case 'visit':// 离职
                    this.rid = e.rid
                    this.showModal = true;
                    break;
                case 'edit':
                    this.$router.push('/resume/edit?rid=' + e.rid);
                    break;
                case 'class':
                    this.rid = e.rid;
                    this.showModalClass = true;
                    break;
                case 'open':// 开启
                    this.confirm({title: '恢复简历', content: `确认恢复该简历？`}, () => {
                        this.http('/manage/resume/open', {rid: e.rid}, (res) => {
                            this.toast({content: '操作成功'});
                            this.getData();
                        }, null, 1);
                    });
                    break;
                default:
                    break;
            }
        },
        // 底部操作
        bottomOptionFun(e) {
            if (this.selectedRowKeys.length === 0) {
                return false;
            }

            switch (e.op) {
                case 'assign':
                    this.rid = this.selectedRowKeys.join(',');
                    this.showModalAssign = true;
                    break;
                case 'close':// 关闭
                    this.confirm({title: '删除简历', content: `确认删除该简历？`}, () => {
                        this.rid = this.selectedRowKeys.join(',');

                        this.http('/manage/resume/close', {rid: this.rid}, (res) => {
                            this.toast({content: '操作成功'});
                            this.getData();
                        }, null, 1);
                    });
                    break;
                default:
                    break;
            }
        },
    },
}
</script>


<style lang="less" src="../../assets/css/list/list.less"></style>
